<template>
    <div class="news-list">
        <!--新闻详情页内容-->

        <div class="news-wrap" @click="toContent()">
            <!--新闻不带图片news-img为false-->
            <div class="news-img" v-if="img">
                <img :src="img" alt="">
            </div>

            <div class="news-content">
                <!--新闻标题-->
                <div class="news-title" v-text="listData.title"></div>
                <!--新闻内容-->
                <div class="news-text" v-text="listData.detail"></div>
                <!--新闻发布时间-->
                <div class="time" v-text="listData.create_time"></div>
            </div>
        </div>
        <hr>
    </div>
</template>

<script>
  export default {
    name: "news-content",
    props: ['listData', 'id', 'from', 'articleId', 'cate', 'img',],
    mounted() {

    },
    data() {
      return {}
    },
    methods: {
      toContent() {
        this.$router.push({path: this.from, query: {id: this.articleId, cate: this.cate,cateTitle:this.cate}})
        console.log(this.from)
      },

    }
  }
</script>

<style scoped lang=less>
    .news-wrap {
        width: 780px;
        height: 130px;
        display: flex;
        margin-top: 20px;

        .news-img > img {
            width: 160px;
            height: 106px;
            object-fit: contain;
        }

        .news-wrap > hr {
            border: 0;
            height: .5px;
            background: #d8d8d8;
            margin-bottom: 24px;
        }

        .news-content {
            margin-left: 16px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            .news-title {
                width: 600px;
                font-size: 18px;
                font-family: MicrosoftYaHei;
                color: rgba(51, 51, 51, 1);
                line-height: 24px;
                font-weight: bold;
                margin-bottom: 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .news-text {
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(102, 102, 102, 1);
                line-height: 19px;
                margin-bottom: 9px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }

            .time {
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(153, 153, 153, 1);
                line-height: 19px;
            }
        }
    }
</style>
